import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from "lodash";
import { Fragment } from "vue-fragment";
import { typeToUsableComponent } from "../mixins/component-selector";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TriggerArguments",
  components: {
    Fragment
  },
  mixins: [typeToUsableComponent],
  props: {
    trigger: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      default: () => ({})
    },
    editing: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    triggerArguments() {
      return this.trigger["trigger-arguments"];
    }
  },
  methods: {
    handleInput(value, id) {
      this.$emit("input", _objectSpread(_objectSpread({}, this.value), {}, {
        [id]: value
      }));
    },
    componentProps(arg) {
      return _objectSpread(_objectSpread({}, this.getPropsByArgumentId(arg)), this.getPropsByArgumentType(arg));
    },
    getPropsByArgumentId(arg) {
      const props = {};
      /* eslint-disable no-fallthrough */
      switch (arg.id) {
        case "status":
          //See dropdown.vue
          props.filterBy = {
            path: "boardId",
            value: get(this.value, "board.value", null)
          };
          break;
      }
      /* eslint-disable no-fallthrough */
      return props;
    },
    getPropsByArgumentType(arg) {
      const props = {};
      /* eslint-disable no-fallthrough */
      switch (arg.type) {
        case "single-option":
          props.valueKey = "value";
        case "multi-option":
          props.items = _valuesInstanceProperty(arg);
          props.id = arg.id;
          break;
      }
      /* eslint-disable no-fallthrough */
      return props;
    }
  }
});